/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const SignFieldSignature16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="nonzero"
            d="M6.25 1c1.694 0 2.793 1.981 2.622 4.01-.121 1.447-1.118 3.173-2.511 4.61l-.097.097.069.108c.314.472.694.754 1.122.795l.108.005c.344 0 .639-.22 1.03-.777l.174-.257.306-.476.135-.198.125-.169c.364-.468.75-.748 1.292-.748.59 0 .996.341 1.284.86.067.12.122.233.178.37l.086.225.28.814.062.168.07.162.096-.026c.214-.07.445-.214.698-.444l.127-.123a.875.875 0 111.238 1.238c-.735.735-1.528 1.131-2.369 1.131-.59 0-.996-.341-1.284-.86a3.344 3.344 0 01-.178-.37l-.086-.225-.291-.845-.386.598c-.738 1.107-1.466 1.702-2.587 1.702-1.096 0-1.95-.504-2.58-1.364l-.08-.11-.05.037c-.801.59-1.662 1.06-2.522 1.338l-.215.065a.875.875 0 11-.481-1.682c.805-.23 1.633-.698 2.395-1.292l.111-.09-.027-.087C3.8 8.162 3.64 6.943 3.626 5.621v-.249C3.632 2.923 4.545 1 6.25 1zm0 1.75c-.382 0-.87 1.026-.875 2.628-.003.842.064 1.622.19 2.308l.033.171.144-.172c.735-.909 1.25-1.869 1.368-2.664l.018-.157c.096-1.142-.443-2.114-.878-2.114zm4.375 2.625a.875.875 0 110 1.75.875.875 0 010-1.75z"
        />
    </AccessibleSVG>
);

export default SignFieldSignature16;
